module.exports = __webpack_public_path__ + "static/img/JPessential1.90e9d8b4.png";